// src/services/TypesService.js
import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const TypesService = {
    get: async ({ token, table }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/types'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { table },
            });
            return response.data;
        } catch (error) {
            console.error('Error en TypesService.get:', error);
            throw error;
        }
    },
};
